/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    negative: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#b2b9bf',
        gradient: null,
        outlineColor: '#2c2e30'
      }
    },
    {
      if: { negative: true },
      tokens: {
        backgroundColor: '#c12335',
        gradient: null,
        outlineColor: '#c12335'
      }
    }
  ],
  tokens: {
    backgroundColor: '#2b8000',
    borderRadius: 12,
    gradient: {
      angle: 135,
      stops: [ { color: '#00784a', stop: 0 }, { color: '#66cc00', stop: 1 } ],
      type: 'linear'
    },
    outlineColor: '#2b8000',
    outlineWidth: 1
  }
}
export default theme
